import { computed, defineAsyncComponent, defineComponent, ref } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { ActivityGetter } from '@/store/activity/activity.module';
import { Activity } from '@/store/activity/activity.model';
import { Province } from '@/store/province/province.model';

export default defineComponent({
  name: 'ActivityProvincePage',
  components: {
    AsyncActivityMemoListComponent: defineAsyncComponent(() => import('@/components/activityMemoList/ActivityMemoList.vue')),
    AsyncActivityBudgetTableComponent: defineAsyncComponent(() => import('@/components/activityBudgetTable/ActivityBudgetTable.vue')),
  },
  setup: () => {
    const route = useRoute();
    const activityId = computed<number>(() => parseInt(route.params.activityId as string));
    const provinceId = computed<number>(() => parseInt(route.params.provinceId as string));
    const store = useStore();
    const activity = computed<Activity | undefined>(() => store.getters[ActivityGetter.BY_ID](activityId.value));
    const province = computed<Province>(() => activity.value?.provinces.find(m => m.id === provinceId.value) as Province);
    const activeTab = ref('memo-list');
    const activityComponent = computed(() => `async-activity-${activeTab.value}-component`);

    const setActive = (tab: string) => {
      activeTab.value = tab;
    };

    return {
      activityId,
      provinceId,
      activityComponent,
      province,
      activeTab,
      setActive,
    };
  },
});
